<app-loader>
  <router-outlet #outlet></router-outlet>
</app-loader>
<app-fileupload-progressbar *ngIf="isFileUploaderActive"></app-fileupload-progressbar>
